import AttachmentEditor from './AttachmentEditor'

export default AttachmentEditor
